import { createContext, useContext } from 'react';

// Marca se o componente está sendo renderizado DENTRO do AppLayout (shell).
// Quando true, Header / Footer / ContextNavBar viram no-op para evitar chrome duplicado.
export const ShellContext = createContext(false);
export const useShell = () => useContext(ShellContext);
